import { PoiCategoryDto } from '../services/api';

export const fallbackPoiCategories: PoiCategoryDto[] = [
  { canonicalId: 'advertising_agency', name: 'advertising agency' },
  { canonicalId: 'african_restaurant', name: 'african restaurant' },
  { canonicalId: 'airport', name: 'airport' },
  { canonicalId: 'airport_gate', name: 'airport gate' },
  { canonicalId: 'airport_terminal', name: 'airport terminal' },
  { canonicalId: 'airport_ticket_counter', name: 'airport ticket counter' },
  { canonicalId: 'alternative_healthcare', name: 'alternative healthcare' },
  { canonicalId: 'american_restaurant', name: 'american restaurant' },
  { canonicalId: 'animal_shelter', name: 'animal shelter' },
  { canonicalId: 'antique_shop', name: 'antique shop' },
  { canonicalId: 'apartment_or_condo', name: 'apartment or condo' },
  { canonicalId: 'aquarium', name: 'aquarium' },
  { canonicalId: 'arcade', name: 'arcade' },
  { canonicalId: 'art', name: 'art' },
  { canonicalId: 'art_gallery', name: 'art gallery' },
  { canonicalId: 'arts_and_craft_store', name: 'arts and craft store' },
  { canonicalId: 'arts_center', name: 'arts center' },
  { canonicalId: 'asian_restaurant', name: 'asian restaurant' },
  { canonicalId: 'assisted_living_facility', name: 'assisted living facility' },
  { canonicalId: 'atm', name: 'atm' },
  { canonicalId: 'auto_repair', name: 'auto repair' },
  { canonicalId: 'baby_goods_shop', name: 'baby goods shop' },
  { canonicalId: 'bagel_shop', name: 'bagel shop' },
  { canonicalId: 'baggage_claim', name: 'baggage claim' },
  { canonicalId: 'bakery', name: 'bakery' },
  { canonicalId: 'bank', name: 'bank' },
  { canonicalId: 'bar', name: 'bar' },
  { canonicalId: 'barbeque_restaurant', name: 'barbeque restaurant' },
  { canonicalId: 'baseball_field', name: 'baseball field' },
  { canonicalId: 'baseball_stadium', name: 'baseball stadium' },
  { canonicalId: 'basketball_court', name: 'basketball court' },
  { canonicalId: 'basketball_stadium', name: 'basketball stadium' },
  { canonicalId: 'beach', name: 'beach' },
  { canonicalId: 'beach_bar', name: 'beach bar' },
  { canonicalId: 'beauty_store', name: 'beauty store' },
  { canonicalId: 'bed_and_breakfast', name: 'bed and breakfast' },
  { canonicalId: 'beer_bar', name: 'beer bar' },
  { canonicalId: 'beer_festival', name: 'beer festival' },
  { canonicalId: 'bicycle_shop', name: 'bicycle shop' },
  { canonicalId: 'biergarten', name: 'biergarten' },
  { canonicalId: 'bike_rental', name: 'bike rental' },
  { canonicalId: 'billiards', name: 'billiards' },
  { canonicalId: 'boat_launch', name: 'boat launch' },
  { canonicalId: 'boat_or_ferry', name: 'boat or ferry' },
  { canonicalId: 'boat_rental', name: 'boat rental' },
  { canonicalId: 'book_store', name: 'book store' },
  { canonicalId: 'bookmaker', name: 'bookmaker' },
  { canonicalId: 'boutique', name: 'boutique' },
  { canonicalId: 'bowling_alley', name: 'bowling alley' },
  { canonicalId: 'boxing_gym', name: 'boxing gym' },
  { canonicalId: 'brazilian_restaurant', name: 'brazilian restaurant' },
  { canonicalId: 'breakfast_restaurant', name: 'breakfast restaurant' },
  { canonicalId: 'brewery', name: 'brewery' },
  { canonicalId: 'bridal_shop', name: 'bridal shop' },
  { canonicalId: 'bridge', name: 'bridge' },
  { canonicalId: 'brunch_restaurant', name: 'brunch restaurant' },
  { canonicalId: 'bubble_tea', name: 'bubble tea' },
  { canonicalId: 'buddhist_temple', name: 'buddhist temple' },
  { canonicalId: 'buffet_restaurant', name: 'buffet restaurant' },
  { canonicalId: 'burger_restaurant', name: 'burger restaurant' },
  { canonicalId: 'bus_line', name: 'bus line' },
  { canonicalId: 'bus_station', name: 'bus station' },
  { canonicalId: 'bus_stop', name: 'bus stop' },
  { canonicalId: 'butcher_shop', name: 'butcher shop' },
  { canonicalId: 'cable_car', name: 'cable car' },
  { canonicalId: 'cafe', name: 'cafe' },
  { canonicalId: 'camera_shop', name: 'camera shop' },
  { canonicalId: 'campground', name: 'campground' },
  { canonicalId: 'canal', name: 'canal' },
  { canonicalId: 'cannabis_dispensary', name: 'cannabis dispensary' },
  { canonicalId: 'car_dealership', name: 'car dealership' },
  { canonicalId: 'car_rental', name: 'car rental' },
  { canonicalId: 'car_wash', name: 'car wash' },
  { canonicalId: 'care_services', name: 'care services' },
  { canonicalId: 'carpet_cleaner', name: 'carpet cleaner' },
  { canonicalId: 'carpet_store', name: 'carpet store' },
  { canonicalId: 'carribean_restaurant', name: 'carribean restaurant' },
  { canonicalId: 'casino', name: 'casino' },
  { canonicalId: 'cave', name: 'cave' },
  { canonicalId: 'cemetery', name: 'cemetery' },
  { canonicalId: 'chairlift', name: 'chairlift' },
  { canonicalId: 'champagne_bar', name: 'champagne bar' },
  { canonicalId: 'charging_station', name: 'charging station' },
  { canonicalId: 'charity', name: 'charity' },
  { canonicalId: 'check_cashing', name: 'check cashing' },
  { canonicalId: 'cheese_shop', name: 'cheese shop' },
  { canonicalId: 'childcare', name: 'childcare' },
  { canonicalId: 'chinese_restaurant', name: 'chinese restaurant' },
  { canonicalId: 'chiropractor', name: 'chiropractor' },
  { canonicalId: 'chocolate_shop', name: 'chocolate shop' },
  { canonicalId: 'church', name: 'church' },
  { canonicalId: 'cinema', name: 'cinema' },
  { canonicalId: 'city', name: 'city' },
  { canonicalId: 'climbing', name: 'climbing' },
  { canonicalId: 'climbing_gym', name: 'climbing gym' },
  { canonicalId: 'clothing', name: 'clothing' },
  { canonicalId: 'clothing_store', name: 'clothing store' },
  { canonicalId: 'cobbler', name: 'cobbler' },
  { canonicalId: 'cocktail_bar', name: 'cocktail bar' },
  { canonicalId: 'coffee', name: 'coffee' },
  { canonicalId: 'coffee_roaster', name: 'coffee roaster' },
  { canonicalId: 'coffee_shop', name: 'coffee shop' },
  { canonicalId: 'college', name: 'college' },
  { canonicalId: 'commercial', name: 'commercial' },
  { canonicalId: 'community_center', name: 'community center' },
  { canonicalId: 'community_college', name: 'community college' },
  { canonicalId: 'concert_hall', name: 'concert hall' },
  { canonicalId: 'conference_center', name: 'conference center' },
  { canonicalId: 'consulting', name: 'consulting' },
  { canonicalId: 'convenience_store', name: 'convenience store' },
  { canonicalId: 'copyshop', name: 'copyshop' },
  { canonicalId: 'corporate_amenity', name: 'corporate amenity' },
  { canonicalId: 'counselling', name: 'counselling' },
  { canonicalId: 'country', name: 'country' },
  { canonicalId: 'county', name: 'county' },
  { canonicalId: 'courthouse', name: 'courthouse' },
  { canonicalId: 'coworking_space', name: 'coworking space' },
  { canonicalId: 'creole_restaurant', name: 'creole restaurant' },
  { canonicalId: 'cricket_club', name: 'cricket club' },
  { canonicalId: 'cruise', name: 'cruise' },
  { canonicalId: 'cuban_restaurant', name: 'cuban restaurant' },
  { canonicalId: 'currency_exchange', name: 'currency exchange' },
  { canonicalId: 'dam', name: 'dam' },
  { canonicalId: 'dance_studio', name: 'dance studio' },
  { canonicalId: 'deli', name: 'deli' },
  { canonicalId: 'dentist', name: 'dentist' },
  { canonicalId: 'department_store', name: 'department store' },
  { canonicalId: 'design_studio', name: 'design studio' },
  { canonicalId: 'dessert_shop', name: 'dessert shop' },
  { canonicalId: 'dialysis_center', name: 'dialysis center' },
  { canonicalId: 'diner_restaurant', name: 'diner restaurant' },
  { canonicalId: 'disc_golf_course', name: 'disc golf course' },
  { canonicalId: 'discount_store', name: 'discount store' },
  { canonicalId: 'distillery', name: 'distillery' },
  { canonicalId: 'dive_bar', name: 'dive bar' },
  { canonicalId: 'doctors_office', name: 'doctors office' },
  { canonicalId: 'dog_park', name: 'dog park' },
  { canonicalId: 'donut_shop', name: 'donut shop' },
  { canonicalId: 'dormitory', name: 'dormitory' },
  { canonicalId: 'driving_range', name: 'driving range' },
  { canonicalId: 'driving_school', name: 'driving school' },
  { canonicalId: 'dry_cleaners', name: 'dry cleaners' },
  { canonicalId: 'duty_free_shop', name: 'duty free shop' },
  { canonicalId: 'education', name: 'education' },
  { canonicalId: 'electronics_shop', name: 'electronics shop' },
  { canonicalId: 'elementary_school', name: 'elementary school' },
  { canonicalId: 'embassy', name: 'embassy' },
  { canonicalId: 'emergency_room', name: 'emergency room' },
  { canonicalId: 'employment_agency', name: 'employment agency' },
  { canonicalId: 'english_restaurant', name: 'english restaurant' },
  { canonicalId: 'entertainment', name: 'entertainment' },
  { canonicalId: 'equipment_rental', name: 'equipment rental' },
  { canonicalId: 'event_planner', name: 'event planner' },
  { canonicalId: 'event_space', name: 'event space' },
  { canonicalId: 'exhibit', name: 'exhibit' },
  { canonicalId: 'fabric_store', name: 'fabric store' },
  { canonicalId: 'factory', name: 'factory' },
  { canonicalId: 'fair_grounds', name: 'fair grounds' },
  { canonicalId: 'farm', name: 'farm' },
  { canonicalId: 'fashion_accessory_shop', name: 'fashion accessory shop' },
  { canonicalId: 'fast_food', name: 'fast food' },
  { canonicalId: 'field', name: 'field' },
  { canonicalId: 'filipino_restaurant', name: 'filipino restaurant' },
  { canonicalId: 'financial_services', name: 'financial services' },
  { canonicalId: 'fire_station', name: 'fire station' },
  { canonicalId: 'fireworks_store', name: 'fireworks store' },
  {
    canonicalId: 'fish_and_chips_restaurant',
    name: 'fish and chips restaurant',
  },
  { canonicalId: 'fishing', name: 'fishing' },
  { canonicalId: 'fishing_store', name: 'fishing store' },
  { canonicalId: 'fishmonger', name: 'fishmonger' },
  { canonicalId: 'fitness_center', name: 'fitness center' },
  { canonicalId: 'florist', name: 'florist' },
  { canonicalId: 'food', name: 'food' },
  { canonicalId: 'food_and_drink', name: 'food and drink' },
  { canonicalId: 'food_court', name: 'food court' },
  { canonicalId: 'food_truck', name: 'food truck' },
  { canonicalId: 'football_stadium', name: 'football stadium' },
  { canonicalId: 'forest', name: 'forest' },
  { canonicalId: 'fountain', name: 'fountain' },
  { canonicalId: 'frame_store', name: 'frame store' },
  { canonicalId: 'french_restaurant', name: 'french restaurant' },
  { canonicalId: 'frozen_yogurt_shop', name: 'frozen yogurt shop' },
  { canonicalId: 'funeral_home', name: 'funeral home' },
  { canonicalId: 'furniture_maker', name: 'furniture maker' },
  { canonicalId: 'furniture_store', name: 'furniture store' },
  { canonicalId: 'garden', name: 'garden' },
  { canonicalId: 'garden_store', name: 'garden store' },
  { canonicalId: 'gas_station', name: 'gas station' },
  { canonicalId: 'gastropub', name: 'gastropub' },
  { canonicalId: 'gay_bar', name: 'gay bar' },
  { canonicalId: 'german_restaurant', name: 'german restaurant' },
  { canonicalId: 'gift_shop', name: 'gift shop' },
  { canonicalId: 'gluten_free_restaurant', name: 'gluten free restaurant' },
  { canonicalId: 'go_kart_racing', name: 'go kart racing' },
  { canonicalId: 'golf_course', name: 'golf course' },
  { canonicalId: 'government', name: 'government' },
  { canonicalId: 'government_offices', name: 'government offices' },
  { canonicalId: 'graffiti', name: 'graffiti' },
  { canonicalId: 'greek_restaurant', name: 'greek restaurant' },
  { canonicalId: 'grocery', name: 'grocery' },
  { canonicalId: 'gun_store', name: 'gun store' },
  { canonicalId: 'gymnastics', name: 'gymnastics' },
  { canonicalId: 'hairdresser', name: 'hairdresser' },
  { canonicalId: 'hardware_store', name: 'hardware store' },
  { canonicalId: 'hawaiian_restaurant', name: 'hawaiian restaurant' },
  { canonicalId: 'health_food_store', name: 'health food store' },
  { canonicalId: 'health_services', name: 'health services' },
  { canonicalId: 'herbalist', name: 'herbalist' },
  { canonicalId: 'high_school', name: 'high school' },
  { canonicalId: 'historic_site', name: 'historic site' },
  { canonicalId: 'hobby_shop', name: 'hobby shop' },
  { canonicalId: 'hockey_stadium', name: 'hockey stadium' },
  { canonicalId: 'home', name: 'home' },
  { canonicalId: 'home_repair', name: 'home repair' },
  { canonicalId: 'hookah_lounge', name: 'hookah lounge' },
  { canonicalId: 'hospital', name: 'hospital' },
  { canonicalId: 'hospital_unit', name: 'hospital unit' },
  { canonicalId: 'hostel', name: 'hostel' },
  { canonicalId: 'hot_dog_stand', name: 'hot dog stand' },
  { canonicalId: 'hotel', name: 'hotel' },
  { canonicalId: 'hotel_bar', name: 'hotel bar' },
  { canonicalId: 'hunting_area', name: 'hunting area' },
  { canonicalId: 'hunting_store', name: 'hunting store' },
  { canonicalId: 'ice_cream', name: 'ice cream' },
  { canonicalId: 'ice_rink', name: 'ice rink' },
  { canonicalId: 'indian_restaurant', name: 'indian restaurant' },
  { canonicalId: 'indonesian_restaurant', name: 'indonesian restaurant' },
  { canonicalId: 'indoor_cycling', name: 'indoor cycling' },
  {
    canonicalId: 'information_technology_company',
    name: 'information technology company',
  },
  { canonicalId: 'insurance_broker', name: 'insurance broker' },
  { canonicalId: 'internet_cafe', name: 'internet cafe' },
  { canonicalId: 'intersection', name: 'intersection' },
  { canonicalId: 'irish_pub', name: 'irish pub' },
  { canonicalId: 'island', name: 'island' },
  { canonicalId: 'it', name: 'it' },
  { canonicalId: 'italian_restaurant', name: 'italian restaurant' },
  { canonicalId: 'japanese_restaurant', name: 'japanese restaurant' },
  { canonicalId: 'jewelry_store', name: 'jewelry store' },
  { canonicalId: 'juice_bar', name: 'juice bar' },
  { canonicalId: 'karaoke_bar', name: 'karaoke bar' },
  { canonicalId: 'kindergarten', name: 'kindergarten' },
  { canonicalId: 'kitchen_store', name: 'kitchen store' },
  {
    canonicalId: 'korean_barbeque_restaurant',
    name: 'korean barbeque restaurant',
  },
  { canonicalId: 'korean_restaurant', name: 'korean restaurant' },
  { canonicalId: 'labor_union', name: 'labor union' },
  { canonicalId: 'laboratory', name: 'laboratory' },
  { canonicalId: 'lake', name: 'lake' },
  { canonicalId: 'landscaping', name: 'landscaping' },
  { canonicalId: 'language_school', name: 'language school' },
  { canonicalId: 'laser_tag', name: 'laser tag' },
  {
    canonicalId: 'latin_american_restaurant',
    name: 'latin american restaurant',
  },
  { canonicalId: 'laundry', name: 'laundry' },
  { canonicalId: 'lawyer', name: 'lawyer' },
  { canonicalId: 'leather_goods', name: 'leather goods' },
  { canonicalId: 'lgbtq_organization', name: 'lgbtq organization' },
  { canonicalId: 'library', name: 'library' },
  { canonicalId: 'lighthouse', name: 'lighthouse' },
  { canonicalId: 'lighting_store', name: 'lighting store' },
  { canonicalId: 'liquor_store', name: 'liquor store' },
  { canonicalId: 'locksmith', name: 'locksmith' },
  { canonicalId: 'lodging', name: 'lodging' },
  { canonicalId: 'lounge', name: 'lounge' },
  { canonicalId: 'luggage_store', name: 'luggage store' },
  { canonicalId: 'marina', name: 'marina' },
  { canonicalId: 'market', name: 'market' },
  { canonicalId: 'martial_arts_studio', name: 'martial arts studio' },
  { canonicalId: 'massage_shop', name: 'massage shop' },
  { canonicalId: 'mattress_store', name: 'mattress store' },
  { canonicalId: 'medical_clinic', name: 'medical clinic' },
  { canonicalId: 'medical_laboratory', name: 'medical laboratory' },
  { canonicalId: 'medical_practice', name: 'medical practice' },
  { canonicalId: 'medical_supply_store', name: 'medical supply store' },
  { canonicalId: 'mediterranean_restaurant', name: 'mediterranean restaurant' },
  { canonicalId: 'meeting_room', name: 'meeting room' },
  { canonicalId: 'mexican_restaurant', name: 'mexican restaurant' },
  {
    canonicalId: 'middle_eastern_restaurant',
    name: 'middle eastern restaurant',
  },
  { canonicalId: 'military_base', name: 'military base' },
  { canonicalId: 'military_office', name: 'military office' },
  { canonicalId: 'miniature_golf', name: 'miniature golf' },
  { canonicalId: 'monument', name: 'monument' },
  { canonicalId: 'mosque', name: 'mosque' },
  { canonicalId: 'motel', name: 'motel' },
  { canonicalId: 'motorcycle_dealer', name: 'motorcycle dealer' },
  { canonicalId: 'motorsports_store', name: 'motorsports store' },
  { canonicalId: 'mountain', name: 'mountain' },
  { canonicalId: 'mountain_hut', name: 'mountain hut' },
  { canonicalId: 'moving_target', name: 'moving target' },
  { canonicalId: 'museum', name: 'museum' },
  { canonicalId: 'music_school', name: 'music school' },
  { canonicalId: 'music_shop', name: 'music shop' },
  { canonicalId: 'music_venue', name: 'music venue' },
  { canonicalId: 'nail_salon', name: 'nail salon' },
  { canonicalId: 'nature_reserve', name: 'nature reserve' },
  { canonicalId: 'neighbourhood', name: 'neighbourhood' },
  { canonicalId: 'news_kiosk', name: 'news kiosk' },
  { canonicalId: 'nightclub', name: 'nightclub' },
  { canonicalId: 'nightlife', name: 'nightlife' },
  {
    canonicalId: 'nongovernmental_organization',
    name: 'nongovernmental organization',
  },
  { canonicalId: 'noodle_restaurant', name: 'noodle restaurant' },
  { canonicalId: 'notary', name: 'notary' },
  { canonicalId: 'observatory', name: 'observatory' },
  { canonicalId: 'office', name: 'office' },
  { canonicalId: 'optician', name: 'optician' },
  { canonicalId: 'optometrist', name: 'optometrist' },
  { canonicalId: 'outdoor_sculpture', name: 'outdoor sculpture' },
  { canonicalId: 'outdoors', name: 'outdoors' },
  { canonicalId: 'outdoors_store', name: 'outdoors store' },
  { canonicalId: 'outlet_store', name: 'outlet store' },
  { canonicalId: 'paper_goods_store', name: 'paper goods store' },
  { canonicalId: 'park', name: 'park' },
  { canonicalId: 'parking_lot', name: 'parking lot' },
  { canonicalId: 'party_store', name: 'party store' },
  { canonicalId: 'pawnshop', name: 'pawnshop' },
  { canonicalId: 'persian_restaurant', name: 'persian restaurant' },
  { canonicalId: 'peruvian_restaurant', name: 'peruvian restaurant' },
  { canonicalId: 'pet_store', name: 'pet store' },
  { canonicalId: 'pharmacy', name: 'pharmacy' },
  { canonicalId: 'phone_store', name: 'phone store' },
  { canonicalId: 'photo_lab', name: 'photo lab' },
  { canonicalId: 'photo_store', name: 'photo store' },
  { canonicalId: 'photographer', name: 'photographer' },
  { canonicalId: 'physiotherapist', name: 'physiotherapist' },
  { canonicalId: 'picnic_shelter', name: 'picnic shelter' },
  { canonicalId: 'pier', name: 'pier' },
  { canonicalId: 'pilates_studio', name: 'pilates studio' },
  { canonicalId: 'pizza_restaurant', name: 'pizza restaurant' },
  { canonicalId: 'place_of_worship', name: 'place of worship' },
  { canonicalId: 'planetarium', name: 'planetarium' },
  { canonicalId: 'playground', name: 'playground' },
  { canonicalId: 'plaza', name: 'plaza' },
  { canonicalId: 'police_station', name: 'police station' },
  { canonicalId: 'political_party_office', name: 'political party office' },
  { canonicalId: 'pop_up_shop', name: 'pop up shop' },
  { canonicalId: 'portuguese_restaurant', name: 'portuguese restaurant' },
  { canonicalId: 'post_office', name: 'post office' },
  { canonicalId: 'prison', name: 'prison' },
  { canonicalId: 'psychic', name: 'psychic' },
  { canonicalId: 'psychological_services', name: 'psychological services' },
  { canonicalId: 'psychotherapist', name: 'psychotherapist' },
  { canonicalId: 'pub', name: 'pub' },
  { canonicalId: 'public_artwork', name: 'public artwork' },
  {
    canonicalId: 'public_transportation_station',
    name: 'public transportation station',
  },
  { canonicalId: 'racecourse', name: 'racecourse' },
  { canonicalId: 'racetrack', name: 'racetrack' },
  { canonicalId: 'radio_studio', name: 'radio studio' },
  { canonicalId: 'rafting_spot', name: 'rafting spot' },
  { canonicalId: 'railway_platform', name: 'railway platform' },
  { canonicalId: 'railway_station', name: 'railway station' },
  { canonicalId: 'light_rail_station', name: 'light rail station' },
  { canonicalId: 'ramen_restaurant', name: 'ramen restaurant' },
  { canonicalId: 'real_estate_agent', name: 'real estate agent' },
  { canonicalId: 'recording_studio', name: 'recording studio' },
  { canonicalId: 'recreation_center', name: 'recreation center' },
  { canonicalId: 'recycling_center', name: 'recycling center' },
  { canonicalId: 'rehabilitation_center', name: 'rehabilitation center' },
  { canonicalId: 'repair_shop', name: 'repair shop' },
  { canonicalId: 'resort', name: 'resort' },
  { canonicalId: 'rest_area', name: 'rest area' },
  { canonicalId: 'restaurant', name: 'restaurant' },
  { canonicalId: 'river', name: 'river' },
  { canonicalId: 'road', name: 'road' },
  { canonicalId: 'rugby_stadium', name: 'rugby stadium' },
  { canonicalId: 'sake_bar', name: 'sake bar' },
  { canonicalId: 'salad_bar', name: 'salad bar' },
  { canonicalId: 'salon', name: 'salon' },
  { canonicalId: 'sandwich_shop', name: 'sandwich shop' },
  { canonicalId: 'sauna', name: 'sauna' },
  { canonicalId: 'school', name: 'school' },
  { canonicalId: 'scuba_diving_shop', name: 'scuba diving shop' },
  { canonicalId: 'seafood_restaurant', name: 'seafood restaurant' },
  { canonicalId: 'service_area', name: 'service area' },
  { canonicalId: 'services', name: 'services' },
  { canonicalId: 'sewing_shop', name: 'sewing shop' },
  { canonicalId: 'shipping_store', name: 'shipping store' },
  { canonicalId: 'shoe_repair', name: 'shoe repair' },
  { canonicalId: 'shoe_store', name: 'shoe store' },
  { canonicalId: 'shopping', name: 'shopping' },
  { canonicalId: 'shopping_mall', name: 'shopping mall' },
  { canonicalId: 'skatepark', name: 'skatepark' },
  { canonicalId: 'ski_area', name: 'ski area' },
  { canonicalId: 'ski_shop', name: 'ski shop' },
  { canonicalId: 'ski_trail', name: 'ski trail' },
  { canonicalId: 'skydiving_drop_zone', name: 'skydiving drop zone' },
  { canonicalId: 'snack_bar', name: 'snack bar' },
  { canonicalId: 'soccer_field', name: 'soccer field' },
  { canonicalId: 'soccer_stadium', name: 'soccer stadium' },
  { canonicalId: 'social_club', name: 'social club' },
  { canonicalId: 'spa', name: 'spa' },
  { canonicalId: 'spanish_restaurant', name: 'spanish restaurant' },
  { canonicalId: 'speakeasy', name: 'speakeasy' },
  { canonicalId: 'sports', name: 'sports' },
  { canonicalId: 'sports_bar', name: 'sports bar' },
  { canonicalId: 'sports_center', name: 'sports center' },
  { canonicalId: 'sports_club', name: 'sports club' },
  { canonicalId: 'sports_shop', name: 'sports shop' },
  { canonicalId: 'stable', name: 'stable' },
  { canonicalId: 'stadium', name: 'stadium' },
  { canonicalId: 'state', name: 'state' },
  {
    canonicalId: 'states_and_municipalities',
    name: 'states and municipalities',
  },
  { canonicalId: 'steakhouse', name: 'steakhouse' },
  { canonicalId: 'storage', name: 'storage' },
  { canonicalId: 'street', name: 'street' },
  { canonicalId: 'stripclub', name: 'stripclub' },
  { canonicalId: 'studio', name: 'studio' },
  { canonicalId: 'summer_camp', name: 'summer camp' },
  { canonicalId: 'supermarket', name: 'supermarket' },
  { canonicalId: 'surf_spot', name: 'surf spot' },
  { canonicalId: 'surfboard_store', name: 'surfboard store' },
  { canonicalId: 'sushi_restaurant', name: 'sushi restaurant' },
  { canonicalId: 'swimming_pool', name: 'swimming pool' },
  { canonicalId: 'synagogue', name: 'synagogue' },
  { canonicalId: 'taco_shop', name: 'taco shop' },
  { canonicalId: 'tailor', name: 'tailor' },
  { canonicalId: 'tanning_salon', name: 'tanning salon' },
  { canonicalId: 'tapas_restaurant', name: 'tapas restaurant' },
  { canonicalId: 'tattoo_parlour', name: 'tattoo parlour' },
  { canonicalId: 'tax_advisor', name: 'tax advisor' },
  { canonicalId: 'taxi', name: 'taxi' },
  { canonicalId: 'teahouse', name: 'teahouse' },
  { canonicalId: 'tech_startup', name: 'tech startup' },
  { canonicalId: 'television_studio', name: 'television studio' },
  { canonicalId: 'temple', name: 'temple' },
  { canonicalId: 'tennis_courts', name: 'tennis courts' },
  { canonicalId: 'tennis_stadium', name: 'tennis stadium' },
  { canonicalId: 'thai_restaurant', name: 'thai restaurant' },
  { canonicalId: 'theatre', name: 'theatre' },
  { canonicalId: 'theme_park', name: 'theme park' },
  { canonicalId: 'theme_park_attraction', name: 'theme park attraction' },
  { canonicalId: 'thrift_shop', name: 'thrift shop' },
  { canonicalId: 'tiki_bar', name: 'tiki bar' },
  { canonicalId: 'tobacco_shop', name: 'tobacco shop' },
  { canonicalId: 'tourist_attraction', name: 'tourist attraction' },
  { canonicalId: 'tourist_information', name: 'tourist information' },
  { canonicalId: 'tours', name: 'tours' },
  { canonicalId: 'town', name: 'town' },
  { canonicalId: 'townhall', name: 'townhall' },
  { canonicalId: 'toy_store', name: 'toy store' },
  { canonicalId: 'track', name: 'track' },
  { canonicalId: 'trade_school', name: 'trade school' },
  { canonicalId: 'trailhead', name: 'trailhead' },
  { canonicalId: 'train', name: 'train' },
  { canonicalId: 'transportation', name: 'transportation' },
  { canonicalId: 'travel agency', name: 'travel agency' },
  { canonicalId: 'tree', name: 'tree' },
  { canonicalId: 'treecare', name: 'treecare' },
  { canonicalId: 'tunnel', name: 'tunnel' },
  { canonicalId: 'turkish_coffeehouse', name: 'turkish coffeehouse' },
  { canonicalId: 'turkish_restaurant', name: 'turkish restaurant' },
  { canonicalId: 'tutor', name: 'tutor' },
  { canonicalId: 'university', name: 'university' },
  { canonicalId: 'university_book_store', name: 'university book store' },
  { canonicalId: 'university_building', name: 'university building' },
  { canonicalId: 'university_laboratory', name: 'university laboratory' },
  { canonicalId: 'vacation_rental', name: 'vacation rental' },
  { canonicalId: 'vape_shop', name: 'vape shop' },
  { canonicalId: 'variety_store', name: 'variety store' },
  { canonicalId: 'veterans_service', name: 'veterans service' },
  { canonicalId: 'veterinarian', name: 'veterinarian' },
  { canonicalId: 'video_game_store', name: 'video game store' },
  { canonicalId: 'video_store', name: 'video store' },
  { canonicalId: 'vietnamese_restaurant', name: 'vietnamese restaurant' },
  { canonicalId: 'viewpoint', name: 'viewpoint' },
  { canonicalId: 'village', name: 'village' },
  { canonicalId: 'vineyard', name: 'vineyard' },
  { canonicalId: 'waffle_shop', name: 'waffle shop' },
  { canonicalId: 'warehouse', name: 'warehouse' },
  { canonicalId: 'waste_disposal', name: 'waste disposal' },
  { canonicalId: 'waste_transfer_station', name: 'waste transfer station' },
  { canonicalId: 'watch_store', name: 'watch store' },
  { canonicalId: 'water_park', name: 'water park' },
  { canonicalId: 'waterfall', name: 'waterfall' },
  { canonicalId: 'well', name: 'well' },
  { canonicalId: 'whiskey_bar', name: 'whiskey bar' },
  { canonicalId: 'wholesale_store', name: 'wholesale store' },
  { canonicalId: 'windmill', name: 'windmill' },
  { canonicalId: 'wine_bar', name: 'wine bar' },
  { canonicalId: 'winery', name: 'winery' },
  { canonicalId: 'wings_joint', name: 'wings joint' },
  { canonicalId: 'womens_clothing_store', name: 'womens clothing store' },
  { canonicalId: 'yoga_studio', name: 'yoga studio' },
  { canonicalId: 'zoo', name: 'zoo' },
  { canonicalId: 'zoo_exhibit', name: 'zoo exhibit' },
];
